<template>
	<v-dialog
		v-model="dialog"
		max-width="900px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn class="mt-2 mb-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-account-multiple-plus</v-icon>
				他の作業者一覧
			</v-btn>
		</template>

		<v-card :tile="$vuetify.breakpoint.xs">
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white">社員選択</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-form ref="form">
				<v-row no-gutters justify="space-between">
					<v-col cols="12" sm="6">
						<v-btn
							color="secondary"
							class="mt-4 ml-4"
							@click="startRequiredTime"
							:disabled="disabledStartButton()"
						>
							<v-icon class="mr-1">mdi-timer-edit-outline</v-icon>
							開始 / 再開
						</v-btn>

						<v-btn
							color="red"
							class="mt-4 ml-2"
							@click="stopRequiredTime"
							:disabled="disabledStopButton()"
							:dark="!disabledStopButton()"
						>
							<v-icon class="mr-1">mdi-timer-off-outline</v-icon>
							中断
						</v-btn>
					</v-col>
					<v-col cols="12" sm="6">
						<v-select
							label="部門選択"
							v-model="q.departments_name_eq"
							:items="departments"
							item-text="name"
							item-value="name"
							no-data-text="データがありません"
							class="mt-4 px-4"
							outlined
							clearable
							dense
							@change="searchDepartmentUsers()"
						/>
					</v-col>
				</v-row>
			</v-form>

			<v-divider></v-divider>

			<div class="table-container mt-4 px-2">
				<v-data-table
					locale="ja-JP"
					v-model="selectedUserIds"
					:items="users"
					item-key="id"
					:headers="headers"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-pagination
					disable-sort
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>
								<v-checkbox
									:class="{ 'is-disabled': disabledCheckbox(item.id) }"
									color="secondary"
									v-model="selectedUserIds"
									@click="selectUser(item.id)"
									:value="item.id"
									:key="item.id"
									hide-details
									item-key="id"
									:disabled="disabledCheckbox(item.id)"
								></v-checkbox>
							</td>
							<td>
								<v-checkbox
									color="red"
									v-model="interruption_user_ids"
									:value="item.id"
									:key="item.id"
									hide-details
									item-key="id"
									v-if="appearInterruptionCheckbox(item.id)"
								></v-checkbox>
							</td>

							<td>
								{{ item.full_name }}
							</td>
							<td>
								<span v-for="(department, i) in item.departments" :key="`department-${i}`"
									>{{ department.name }}/</span
								>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
			<PaginationModule :pagination="pagination" @get-page="getPage($event)" />
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import PaginationModule from "../../../modules/PaginationModule.vue"

export default {
	props: {
		checkProcess: {
			type: Object,
			required: true,
		},
		orderIndividualInfoId: {
			type: null,
			required: true,
		},
	},
	components: {
		PaginationModule,
	},

	data() {
		return {
			title: "社員一覧",
			dialog: false,
			headers: headers(),
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				departments_name_eq: "製造部",
			},
			users: [],
			selectedUserIds: [],
			departments: [],
			unfinished_required_time_user_ids: [],
			difference_ids: [],
			interruption_user_ids: [],
		}
	},

	methods: {
		fetchUserInfos(q, page, id, assignment) {
			const headers = authenticate.setHeader()
			const params = { q, page, check_process_id: id }

			axios
				.get("/erp/v1/manufactures/users", {
					params,
					headers,
				})
				.then((res) => {
					this.users = res.data.users
					this.departments = res.data.departments
					this.unfinished_required_time_user_ids = res.data.unfinished_required_time_users
					if (assignment) {
						this.selectedUserIds = this.unfinished_required_time_user_ids.map((user_id) => user_id)
					}
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},

		getPage(page) {
			if (page) {
				this.fetchUserInfos(this.q, page, this.checkProcess.id)
			} else {
				var page = this.$route.query.page ? this.$route.query.page : 1
				this.fetchUserInfos(this.q, page, this.checkProcess.id)
			}
		},

		searchDepartmentUsers() {
			this.fetchUserInfos(this.q, 1, this.checkProcess.id)
		},

		startRequiredTime() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/manufactures/user_required_times`

			if (this.checkProcess.situation == "planned") {
				var params = {
					check_process_id: this.checkProcess.id,
					user_ids: this.difference_ids,
					status: "start",
					id: this.orderIndividualInfoId,
				}
			} else if (this.checkProcess.situation == "ongoing") {
				var params = {
					check_process_id: this.checkProcess.id,
					user_ids: this.difference_ids,
					status: "restart",
					id: this.orderIndividualInfoId,
				}
			}

			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					if (res.data.status == "start") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "作業を開始しました",
						})
					} else if (res.data.status == "restart") {
						this.$store.dispatch("setFlash", {
							type: "notice",
							text: "作業を再開しました",
						})
					}
					this.difference_ids = []
					this.checkProcess.situation = res.data.check_process.situation
					this.unfinished_required_time_user_ids = this.unfinished_required_time_user_ids.concat(
						res.data.user_ids.map((user_id) => user_id)
					)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		stopRequiredTime() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/manufactures/user_required_times/${this.orderIndividualInfoId}`

			const params = {
				check_process_id: this.checkProcess.id,
				user_ids: this.interruption_user_ids,
			}

			axios
				.put(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "作業を中断しました",
					})
					this.interruption_user_ids = []
					this.unfinished_required_time_user_ids = this.unfinished_required_time_user_ids.filter(
						(user_id) => {
							return !res.data.user_ids.includes(user_id)
						}
					)
					this.selectedUserIds = this.unfinished_required_time_user_ids.concat(this.difference_ids)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		disabledCheckbox(user_id) {
			return this.unfinished_required_time_user_ids.includes(user_id)
		},
		appearInterruptionCheckbox(user_id) {
			return this.unfinished_required_time_user_ids.includes(user_id)
		},
		disabledStartButton() {
			return (
				(this.checkProcess.situation != "ongoing" || this.checkProcess.situation != "planned") &&
				this.difference_ids.length <= 0
			)
		},
		disabledStopButton() {
			return this.interruption_user_ids.length <= 0
		},

		selectUser() {
			this.difference_ids = this.selectedUserIds.filter((id) => {
				return !this.unfinished_required_time_user_ids.includes(id)
			})
		},
	},
	watch: {
		checkProcess(newVal, oldVal) {
			if (newVal.id == oldVal.id) return
			this.fetchUserInfos(this.q, 1, newVal.id, true)
		},
		deep: true,
	},
}

function headers() {
	return [
		{
			text: "開始選択",
			width: "50px",
		},
		{
			text: "中断選択",
			width: "50px",
		},
		{
			text: "社員名",
			value: "full_name",
			width: "150px",
		},

		{
			text: "所属部門",
			value: "departments",
			width: "200px",
		},
	]
}
</script>

<style lang="scss" scoped>
.is-disabled {
	opacity: 0.5;
}

.is-disabled-text {
	color: #aaa;
}
</style>
